
import { mapState } from 'vuex'
import DeliveryCertNew from './deliveryCertNew.vue'
import CtPhoneVerify from '@/components/phoneVerify/index.vue'
import { parseVocCode } from './utils.js'
import { waybillMap, timeZone, appleHotLineMap, isAppleWaybill } from '@/utils/const'
import { hasSamsungReceiverBtn, hasSamsungAppointmentBtn } from '@/utils/const'
import SignaturePad from 'signature_pad'
import { temporary, processDataAndSave } from '@/utils/cookieOperation.js'
import { deliveryType } from './utils.js'
// deliveryCertNew.vue 内部通过 web_proof_flow_rules CMS 配置控制 tab 展示

export default {
  components: {
    DeliveryCertNew,
    CtPhoneVerify,
  },
  props: {
    route: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    hasDash: {
      type: Boolean,
      default: false,
    },
    isLocalQuery: {
      type: Boolean,
      default: false,
    },
    isLocalTime: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deliveryModal: false,
      podModal: false,
      visible: false,
      timeZoneOptions: timeZone,
      signatureVisible: false,
      signaturePad: null,
      isNoSignature: false,
      signaturePadType: true,
      timer: null,
    }
  },
  computed: {
    ...mapState({
      site: (state) => state.site,
      lang: (state) => state.lang,
    }),
    isSgSite() {
      return this.site.toUpperCase() === 'SG'
    },
    getCurTimeZoneLabel() {
      return (timeZone) => {
        if (!timeZone) return ''
        const o = this.timeZoneOptions.find((item) => item.value === timeZone)
        return o?.label || ''
      }
    },
    isShowDelivery() {
      return (route) => {
        return this.isSigned(route)
      }
    },
    isSamsung() {
      return this.$route.query.customer_type === 'samsung'
    },
    // 是否已登录
    isLoggedIn() {
      const { loginToken, loginUser } = this.$store.state || {}
      return !!(loginToken && loginUser)
    },
    // 是否伪登录
    isPseudoLogin() {
      return !!(this.$route.query && this.$route.query.encryptedPhone)
    },
    // 伪登录加密手机号
    encryptedPhone() {
      const raw = (this.$route.query && this.$route.query.encryptedPhone) || ''
      return raw ? encodeURIComponent(raw) : ''
    },
    setSignNow() {
      let type = this.route.barNewList.some((item) => {
        return ['80', '8000'].includes(item.opCode)
      })
      return this.route.destCountryCode == 'KR' && type
    },
    shouldShowDeliveryDateButton() {
      const hasCommonCondition =
        this.hasSamsungAppointmentBtn(this.route) &&
        this.isShowDirective(this.route)
      return (
        (this.isSigned(this.route) && hasCommonCondition) ||
        (!this.isAppleWaybill(this.route.waybillNo) && hasCommonCondition)
      )
    },
    shouldShowDeliveryPreferenceButton() {
      // 目的地为日本或韩国（需满足 url-params: hasJpEntry/hasKrEntry=true+个人件+未签收）且未签收时展示
      const isJP = this.route.destCountryCode == 'JP' && this.isJPRoute
      const isKR = this.route.destCountryCode == 'KR' && this.isKRRoute
      return (isJP || isKR) && this.route.barNewList && this.route.barNewList.length > 0
    },
    // KR 路线已选过派送方式则隐藏编辑按钮（校验前置）
    isKRDeliveryPreferenceDisabled() {
      const isKR = this.route.destCountryCode == 'KR' && this.isKRRoute
      return isKR && this.route.communicateType
    },

    isKRRoute() {
      const hasKrEntry = this.$route.query.hasKrEntry === 'true'
      const isKRCountry = this.route.destCountryCode === 'KR'
      const notSigned = !this.isSigned(this.route)
      const isPersonal = this.route.receiverRemark === '01'
      return hasKrEntry && isKRCountry && isPersonal && notSigned
    },
    isJPRoute() {
      const hasJpEntry = this.$route.query.hasJpEntry === 'true'
      const isJPCountry = this.route.destCountryCode === 'JP'
      const notSigned = !this.isSigned(this.route)
      const isPersonal = this.route.receiverRemark === '01'
      return hasJpEntry && isJPCountry && isPersonal && notSigned
    },
    deliveryTypeName() {
      const vocCode = parseVocCode(this.route.communicateType)
      return this.$t(deliveryType[vocCode] || '')
    },
    // 预排序 barNewList，避免多处重复排序
    _sortedBars() {
      const list = this.route?.barNewList || []
      return [...list].sort((a, b) => {
        const timeA = (a.barScanDt || '') + ' ' + (a.barScanTm || '')
        const timeB = (b.barScanDt || '') + ' ' + (b.barScanTm || '')
        return timeB.localeCompare(timeA)
      })
    },
    _barState() {
      const bars = this._sortedBars
      const hasSigned = bars.some(item => item.opCodeStatus === 'signed')
      const latest = bars[0] || null
      let statusType = 'awaiting_pickup'
      if (latest) {
        const matched = waybillMap.find(item => item.valueKey === latest.opCodeStatus)
        statusType = matched ? matched.type : 'other'
      }
      const signedItem = bars.find(item => item.opCodeStatus === 'signed') || null
      return { hasSigned, statusType, signedItem }
    },
    // 获取签收证明按钮文案
    getProofText() {
      // 日本站 + 日语 
      if(this.site  == 'jp' && this.lang == 'ja') {
        return this.$t('serviceSupport.querySupport.prove.proof')
      }
      return  this.$t('button.view') + this.$t('serviceSupport.querySupport.prove.proof')
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
    // 销毁 SignaturePad 实例
    if (this.signaturePad) {
      this.signaturePad.off() // 移除事件监听器
      this.signaturePad.clear() // 清理画布
      this.signaturePad = null
    }
  },
  methods: {
    getGroupedNodes(list) {
      if (!list || !list.length) return []
      // 使用预排序结果，避免重复排序
      const sorted = this._sortedBars
      const result = []
      let lastDate = ''

      sorted.forEach((item, idx) => {
        const currentDate = item.barScanDt
        if (currentDate !== lastDate) {
          result.push(
            {
              type: 'date',
              value: currentDate,
            },
            {
              type: 'node',
              data: item,
              index: idx,
              isLast: idx === list.length - 1,
            }
          )
          lastDate = currentDate
        } else {
          result.push({
            type: 'node',
            data: item,
            index: idx,
            isLast: idx === list.length - 1,
          })
        }
      })
      return result
    },
    getSvgName(name) {
      const names = [
        'collect',
        'delivered',
        'delivery',
        'express-direction',
        'invalid',
        'landing',
        'other',
        'packaged',
        'pickedup',
        'picking',
        'received',
        'signed',
        'take_off',
      ]
      return names.includes(name) ? name : 'other'
    },
    // 点击单个收起方法
    clickFold(index) {
      this.$emit('toggle', index)
    },
    // 获取当前状态类型，运送中，已签收，已作废，配送准备中
    getCurStatusTypeI18n(arrList) {
      return this._barState.statusType
    },
    // 获取当前状态国际化
    getCurStatusI18n(curItem) {
      const matched = waybillMap.find(
        (item) => item.valueKey === curItem.opCodeStatus
      )
      if (!matched) {
        return 'serviceSupport.querySupport.waybills.opCode_other'
      }
      return matched?.il8nName
    },
    // 是否已签收
    isSigned(route) {
      return this._barState.hasSigned
    },
    // 获取签收时间或者预计送达时间
    getFinalTime(route) {
      const signedItem = this._barState.signedItem
      if (signedItem) {
        return signedItem.barScanDt + ' ' + signedItem.barScanTm
      } else {
        return route?.pisDeliveryTm?.queryPromise || ''
      }
    },
    isAppleWaybill,
    // 当前苹果热线显示
    curAppleHotLine(route) {
      let text = ''
      // 不同国家配置
      const { waybillNo, destCountryCode } = route
      const matchedItem =
        appleHotLineMap[destCountryCode?.toLowerCase()] ||
        appleHotLineMap.default
      if (isAppleWaybill(waybillNo) && matchedItem) {
        const { title, mobile, countryName } = matchedItem
        text = this.$t('serviceSupport.querySupport.waybills.appleTip', [
          this.$t(title),
          mobile,
          this.$t(countryName),
        ])
      }
      return text
    },
    getReDecode(waybillNo) {
      this.$emit('reDecode', waybillNo)
    },
    // 反脱敏数据
    // 反脱敏数据
    async getDecodeData(params = {}, cap = {}) {
      try {
        const { customer_type: customerType } = this.$route.query
        if (customerType === 'samsung') {
          params.customer_type = customerType
        }
        const result = await this.$API.support.billRouteApi(params, cap)
        if (result && result.length) {
          this.visible = false
          if (this.isNoSignature) {
            this.showSignature({
              mobileNoLast4: params.mobileNoLast4,
              destCountryCode: result[0].destCountryCode,
            })
          } else {
            this.$emit('decode', result)
          }
        }
      } catch (error) {
        console.error('Failed to get decode data:', error)
        this.$message.error(this.$t('common.http.dataError'))
      }
    },
    showDialog(route) {
      // 统一走 DeliveryCert（签收证明/派送证明/签收底单 tab 由 deliveryCert 内部 CMS 检查控制）
      this.showDelivery(route.waybillNo)
    },
    showDelivery(waybill) {
      this.deliveryModal = true
    },
    showPOD(waybill) {
      this.podModal = true
    },
    updateRecipient(type) {
      console.log('点击收件人按钮', type)
      // 1 预约派送日期  2 修改收件人信息
      this.$emit('updateRecipientModal', type)
    },
    updateDeliveryPreference() {
      this.$emit('updateDeliveryPreference')
    },
    hasSamsungReceiverBtn,
    hasSamsungAppointmentBtn,
    isShowDirective(it) {
      if ((!this.isSamsung && it.changeOrderControl !== 0) || !this.isSgSite) {
        return false
      } else if (it.productCode != 'SE0054') {
        return true
      } else {
        return true
      }
    },
    showSignature(res) {
      this.signatureVisible = true

      if (this.timer) {
        clearTimeout(this.timer)
      }

      this.timer = setTimeout(() => {
        const canvas = this.$refs.signaturePad
        this.signaturePad = new SignaturePad(canvas, {
          // 可以配置的选项，例如最小宽度、背景颜色等
          minWidth: 0.5,
          maxWidth: 2.5,
          penColor: 'rgb(0, 0, 0)',
          backgroundColor: '#F7F8FA',
        })
        this.getReceiptRecord(res)
      }, 0)
    },
    async getReceiptRecord(res) {
      let param = {
        businessCode: 6,
        waybillNo: this.route.waybillNo,
        imageType: 5,
        ...res,
      }
      const result = await this.$API.support.getReceiptRecord(param)
      if (result) {
        let TemporaryData = processDataAndSave(result, temporary) //保存token
        this.$store.dispatch('support/setApplTemporaryData', TemporaryData)
      }

      if (result?.length && result[0]?.fileUrl) {
        // this.signaturePad && this.signaturePad.fromDataURL('data:image/jpg;base64,' + result[0].imageData)
        this.signaturePad && this.signaturePad.fromDataURL(result[0].fileUrl)
        this.signaturePadType = false
      }
      // this.signaturePad.fromDataURL('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAooAAAEsCAYAAABE2ZLiAAAAAXNSR0IArs4c6QAAIABJREFUeF7t3Xd8FVX6x/GHRSChSJXeRUB6B+ldAqGjQICVDtISQKUlaBKKdFBJ6HXpvXdYwEYTEAUsqygKrLgoIAFE5fc7h01WFOEkuTd37j2f+Wfdl+fOPM/7mddrvzuTmUl289bPd4UNAQQQQAABBBBAAIE/CCQjKHJOIIAAAggggAACCDxIgKDIeYEAAggggAACCCDwQAGCIicGAggggAACCCCAAEGRcwABBBBAAAEEEEDAXIAriuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrEQAAQQQQAABBKwSIChaNW6aRQABBBBAAAEEzAUIiuZWrHSjwOTJk/TeBw0a7MajsGsEEEAAAQQQiI8AQTE+Wqx1i8C0qVNk6NAhet+vvz5OgkMGuuU47BQBBBBAAAEE4idAUIyfF6vdINCnT2+ZP2+e3vPgwS/JqNFj3HAUdokAAggggAAC8RUgKMZXjPUuF+jXt4/MnTtH73fnrt1So0ZNlx+DHSKAAAIIIIBA/AUIivE34xcuFnj++TayaeNGvdcPjp+Up59+2sVHYHcIIIAAAgggkBABgmJC1PiNSwUqlC8rH3/8sd7nhQuXJGOmTC7dPztDAAEEEEAAgYQJEBQT5savXCjwRJZM8tNPP4m/v79c+eGqC/fMrhBAAAEEEEAgMQIExcTo8dtEC8TExEjmTBn0fp566in58NS9K4tsCCCAAAIIIOB5AYKi52dgdQVffPGFFC9WVBtUrVpN9uzdZ7UHzSOAAAIIIOAkAYKik6ZhYS3vvfeu1K1TW3feomVLWbZshYUKtIwAAggggIAzBQiKzpyLNVVt3LBB2rZ9TvfbvXsPefOt6db0TqMIIIAAAgg4XYCg6PQJ+Xh9M2ZEy8CQYN1laGiYjAgN8/GOaQ8BBBBAAAHvESAoes+sfLLSyMgIGTN6lO5t/PgJ0n/AvdDIhgACCCCAAAKeFyAoen4GVlfQ58XeMn/+vc/3zZ03X4KCOljtQfMIIIAAAgg4SYCg6KRpWFhL61YtZevWLbrzVavXSmBgoIUKtIwAAggggIAzBQiKzpyLNVVVqVJJTp44ofvdf+CgVKpU2ZreaRQBBBBAAAGnCxAUnT4hH6/vyYL55cKFC7rLw0eOScmSJX28Y9pDAAEEEEDAewQIit4zK5+r9LfffpM0qf3i+vrXF+ckZ86cPtcnDSGAAAIIIOCtAgRFb52cD9R98eJFKVggX1wnl7+/ImnTpvWBzmgBAQQQQAAB3xAgKPrGHL2yi6NHjkiNGtV07cmTJ5frP8VIsmTJvLIXikYAAQQQQMAXBQiKvjhVL+lp7Zo10qFDe11tpkyZ5dsLF72kcspEAAEEEEDADgGCoh1zdmSX0dFRMmhgiK6tcOHCcvLDjxxZJ0UhgAACCCBgqwBB0dbJO6DvQYMGSnTUvW87FyteXI4dO+6AqigBAQQQQAABBGIFCIqcCx4TKFumlJw9e1YfP1++fHL2k888VgsHRgABBBBAAIE/CxAUOSs8JlCjejU5evSIPn7NmrVkx85dHquFAyOAAAIIIIAAQZFzwEEC5cqWljNnzuiK+g8IlvHjJzioOkpBAAEEEEAAAa4ocg54TCB79qxy9ccf9fHDwyPklSFDPVYLB0YAAQQQQAABrihyDjhEICYmRjJnyhBXTfSMmdK5cxeHVEcZCCCAAAIIIKAEuKLIeeARgT9+lWXd+g3SqFGAR2rhoAgggAACCCDwYAGCImeGRwR+/1UWVcA/9x+QypWreKQWDooAAggggAACBEXOAQcJbN68WZ5r0yquok8/+5fkyZPHQRVSCgIIIIAAAghwRZFzwCMCy5Ytla5dOscd+4cfr4mfn59HauGgCCCAAAIIIMAVRc4BBwlMnTJZhg2795RzqlSpRAXFZMmSOahCSkEAAQQQQAABrihyDnhEIDR0hEyaeO+9iQUKFJDTZz7xSB0cFAEEEEAAAQT+WoCgyNnhEYH+/frKnDmz9bHLV6ggb7/9rkfq4KAIIIAAAgggQFDkHHCYQFBQO1m3dq2uKiCgsaxdt95hFVIOAggggAACCHBFkXPAIwLNmgbKrl079bGfb9tWFi5c7JE6OCgCCCCAAAIIcEWRc8BhArVq1pDDhw/pqvr16y8TJk5yWIWUgwACCCCAAAJcUeQc8IhApYrl5dSpU/rYw0eESljYSI/UwUERQAABBBBAgCuKnAMOEyherKh88cUXuqqJkyZL3779HFYh5SCAAAIIIIAAVxQ5BzwiUCB/Prl06aI+9oIFi6Rtu3YeqYODIoAAAggggABXFDkHHCaQK2cOuXLlP7qqrdu2S506dR1WIeUggAACCCCAAFcUOQc8IpAtaxa5du2aPrZ6h6J6lyIbAggggAACCDhLgKDorHlYU03mTBkkJiZG93vm7KeSP39+a3qnUQQQQAABBLxFgKDoLZPysTp/HxSv/HBV/P39faxD2kEAAQQQQMD7BQiK3j9Dr+wgQ/p0cvv2bXnsscfk2vUbkixZMq/sg6IRQAABBBDwZQGCoi9P18G9pUntJ7/99psUKFBATp/5xMGVUhoCCCCAAAL2ChAU7Z29RzuPDYoVKlaUgwff8WgtHBwBBBBAAAEEHixAUOTM8IhA2jT+8uuvv0qTJk1k9Zp1HqmBgyKAAAIIIIDAwwUIipwhHhHImOFxuXXrlnTu3EWiZ8z0SA0cFAEEHizwzTffyPDhQ2XVypV6wY6du6RmzVpwIYCAhQIERQuH7oSWY289B4cMlNdfH+eEkqgBAWsF1Kuqpk2dImPGjJZffvnlgQ69evWWqdPesNaIxhGwVYCgaOvkPdx3urSp9f8gjRs3XgYEh3i4Gg6PgL0Cn3/+ubRu1UI+/fRTKVuunKRLm05j5MqVS/xT+8u8uXPjcEaEhkloaJi9WHSOgIUCBEULh+6ElmNvPc+bv0Datw9yQknUgIAVAmfOnJF33nlbVEA8euSI/ufq1WtI2MiRD7y9fPDgAWnYoL62yZcvn5z95DMrnGgSAQTuCRAUORM8IhD7Cb9t23dI7dp1PFIDB0XA1wVu3LghR48ekUPvvy/HPjgmGzdsuK/lzJkzy8CBg/RV/RQpUvwlh79fyrh/N2r0aBk8+GVfp6M/BBD4rwBBkVPBIwKxVxSPHjsuxYsX90gNHPR/ApcuXZRGjZ6V/Pnyy/oNG6HxUgH1/fSdO3bIqY9Oyd69e/QVw9gtb968+pvqZcuUlUqVK0uFChUlTZo0Rp02qF9P3n77oF779xdekJkzZxv9jkUIIOD9AgRF75+hV3aQJXNGUVc7vr1wUTJlyuyVPfhK0RMnjJfIyAj5+eefxc/PT9QnFflSjvdM9/DhQ/rp5PcPvX9fMHzmmapSvnx5qVmrtv7PnDlzJripWjVriDqO2ooUKSonTn6Y4H3xQwQQ8C4BgqJ3zctnqlUPs9y9e1eu/xRDKPHAVFUoXLZsqcyYES0njh/XYT1btqyi/n5tzJix0n9AsP68IpszBbZu3SKLFi2UgwcOypUr//lvgCsiNWrUlLp160mjgACXfj/92YYN5MCB/XEYN2/97EwYqkIAAZcLEBRdTsoOTQTUrWd19eripe9MlrPGhQIrli+Xt6a/qa8+pU2bVpoEBsq0aW/Kvz7/XBo1aijXr1+XGTNnyQsvdHbhUdlVYgRu3rwpa9as1jNbuHCBfgep2lQwDAwMlIbPNpKiRYsm5hAP/e3MmTMkJHhA3Jq3pkdJt27d3XY8dowAAs4RICg6ZxbWVHLnzh1Rt57z5MkjH318xpq+Pdno7du3Zd68uTJp4gT59ttvJWXKlNK8RQsZO3acfg1K7DZqVKSMHhWpw8eq1Ws9WbL1x1ZhcPfu3bJzx3aZPXtWnEez5s2lfv0GEhDQWHLnzp
    },
    getFormData(bytes) {
      var array = []
      for (var i = 0; i < bytes.length; i++) {
        array.push(bytes.charCodeAt(i))
      }
      var blob = new Blob([new Uint8Array(array.length)], { type: 'image/jpg' })
      // var fd = new FormData();
      // fd.append('file',blob, Date.now() + '.png');
      return blob
    },
    async handleOk() {
      // 确定
      const data = this.signaturePad?.toDataURL('image/jpg') // 获取签名的数据URL
      let bytes = window.atob(data.split(',')[1])
      let param = {
        imageType: '5',
        waybillNo: this.route.waybillNo,
        base64Str: data,
      }
      const result = await this.$API.support.saveReceiptRecord(param)
      if (result) {
        this.$message.success(this.$t('common.submitSucc'))
        this.signatureVisible = false
        this.handleCancel()
      }
    },
    handleCancel(type) {
      this.signaturePad.clear()
    },
    isEmpty() {
      return this.signaturePad?.isEmpty()
    },
  },
}
